import React from 'react';

export const DownloadSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <path
            fill="currentColor"
            d="M12 3a1 1 0 0 0-1 1v6c0 .681.116 1.478.269 2.234l-.143.143a1 1 0 0 1-.11-.149c-.496-.818-1.126-1.748-1.758-2.384l-.55-.551A1 1 0 0 0 7.286 10.7l4.006 4.006a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.411-1.417l-.003.003-.536.535c-.637.638-1.273 1.575-1.774 2.4q-.049.081-.109.15l-.143-.144C12.884 11.478 13 10.68 13 10V4a1 1 0 0 0-1-1"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M20 13a1 1 0 0 1 1 1v3a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4v-3a1 1 0 1 1 2 0v3a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-3a1 1 0 0 1 1-1"
            clipRule="evenodd"
        />
    </svg>
);
